import { render, staticRenderFns } from "./RequestSubmitted.vue?vue&type=template&id=126d7c82&scoped=true&"
import script from "./RequestSubmitted.vue?vue&type=script&lang=js&"
export * from "./RequestSubmitted.vue?vue&type=script&lang=js&"
import style0 from "./RequestSubmitted.vue?vue&type=style&index=0&id=126d7c82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d7c82",
  null
  
)

export default component.exports